import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {fetchSendVerificationCode, fetchCheckVerificationCode} from "./actions";

export interface IEmailVerificationState {
    isLoading: boolean;
    codeSent: boolean;
    isVerified: boolean;
    resendAfter: number;      // секунды до повторной отправки (с сервера)
    verifiedEmail: string;    // email, для которого код подтверждён
}

const initialState: IEmailVerificationState = {
    isLoading: false,
    codeSent: false,
    isVerified: false,
    resendAfter: 0,
    verifiedEmail: "",
};

export const EmailVerificationSlice = createSlice({
    name: "emailVerification",
    initialState,
    reducers: {
        resetVerification: (state) => {
            state.codeSent = false;
            state.isVerified = false;
            state.resendAfter = 0;
            state.verifiedEmail = "";
        },
        // Сброс при смене email в поле
        resetVerificationOnEmailChange: (state) => {
            state.codeSent = false;
            state.isVerified = false;
        },
    },
    extraReducers: (builder) => {
        builder
            // sendCode
            .addCase(fetchSendVerificationCode.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchSendVerificationCode.fulfilled, (state, action: PayloadAction<{ resend_after: number }>) => {
                state.isLoading = false;
                state.codeSent = true;
                state.resendAfter = action.payload.resend_after;
            })
            .addCase(fetchSendVerificationCode.rejected, (state) => {
                state.isLoading = false;
            })
            // checkCode
            .addCase(fetchCheckVerificationCode.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchCheckVerificationCode.fulfilled, (state, action: PayloadAction<{ email: string }>) => {
                state.isLoading = false;
                state.isVerified = true;
                state.verifiedEmail = action.payload.email;
            })
            .addCase(fetchCheckVerificationCode.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

export const {resetVerification, resetVerificationOnEmailChange} = EmailVerificationSlice.actions;
export default EmailVerificationSlice.reducer;